// Ensure the phone field contains only allowed characters on change
export default function usePhonePattern () {
    const phoneInput = document.getElementById( "id_phone_number" )

    phoneInput.addEventListener( "input", handleInput )

    function handleInput ( event ) {
        const value = event.target.value

        // Remove disallowed characters
        // Only digits, spaces, +,_ and parentheses are allowed in the phone field.
        phoneInput.value = value.replace( /[^\d +\-()]/g, "" )
    }
}
